import { createSelector } from "reselect"

// selectors
import { selectFrequencyTupleField } from "app/static/frontend/widgets/selectors/visWidgetSelectors"
import { selectWidgetMeta, selectWidgetQuorumDataType } from "app/static/frontend/widgets/selectors/selectors"

// helpers
import {
    mapVisualizationDataReplacementKeys,
    mapGlobalVisualizationDataReplacementKeys,
} from "app/static/frontend/widgets/helpers/visualization/mapVisualizationWidgetHelpers"

// constants
import mapVisualizationWidgetConstants from "app/static/frontend/widgets/constants/visualization/mapVisualizationWidgetConstants"

export const selectMapVisualizationMetaValue = (key) =>
    createSelector(selectWidgetMeta, (meta) => meta && meta.vis_options[key])

export const selectMapVisualizationData = createSelector(
    (state, props) => props.data,
    selectWidgetQuorumDataType,
    selectFrequencyTupleField,
    selectMapVisualizationMetaValue("map_visualization_region"),
    (data, qdt, frequencyTupleField, mapVisualizationRegion) => {
        if (data) {
            if (frequencyTupleField === DjangIO.app.widgets.types.FrequencyTupleFields.heat.value) {
                return Object.entries(data).reduce((acc, datum) => {
                    // same logic as
                    // app/static/frontend/widgets/components/visualization/hooks/bar/barHooks.js useBarVisualizationData
                    // but for Maps
                    let [id, { groupKeyValue, agg }] = datum
                    const field = groupKeyValue || id
                    let fieldSubstitue = mapVisualizationDataReplacementKeys[field] || field

                    if (
                        Userdata.isGlobalMode() &&
                        mapVisualizationRegion === DjangIO.app.widgets.types.MapVisualizationRegion.world.value
                    ) {
                        fieldSubstitue = mapGlobalVisualizationDataReplacementKeys[field] || field
                        agg += acc[fieldSubstitue]?.agg || 0
                    }

                    if (fieldSubstitue) {
                        acc[fieldSubstitue] = {
                            agg,
                            originalKey: id,
                        }
                    }

                    return acc
                }, {})
            } else if (frequencyTupleField === DjangIO.app.widgets.types.FrequencyTupleFields.point.value) {
                return data.map((datum) => ({
                    id: datum[0],
                    name: datum[1],
                    address: datum[2],
                    latitude: datum[3],
                    longitude: datum[4],
                }))
            }
        }

        switch (frequencyTupleField) {
            case DjangIO.app.widgets.types.FrequencyTupleFields.heat.value:
                switch (mapVisualizationRegion) {
                    case DjangIO.app.widgets.types.MapVisualizationRegion.world.value:
                    default:
                        return mapVisualizationWidgetConstants.heatWorld
                    case DjangIO.app.widgets.types.MapVisualizationRegion.us.value:
                        return mapVisualizationWidgetConstants.heatUS
                }
            case DjangIO.app.widgets.types.FrequencyTupleFields.point.value:
                switch (mapVisualizationRegion) {
                    case DjangIO.app.widgets.types.MapVisualizationRegion.world.value:
                    default:
                        return mapVisualizationWidgetConstants.pointWorld
                    case DjangIO.app.widgets.types.MapVisualizationRegion.us.value:
                        return mapVisualizationWidgetConstants.pointUS
                    case DjangIO.app.widgets.types.MapVisualizationRegion.eu.value:
                        return mapVisualizationWidgetConstants.pointEU
                }
            default:
                return {}
        }
    }
)
